import { Route, RouterProvider } from '../../libs/gs-component-right-rail';
import { useHistory } from 'react-router-dom';
import React from 'react';

import { useWeddingWebsiteQuery } from '../../generated/graphql';
import { Deactivate } from './Deactivate';
import { EditPassword } from './EditPassword';
import { EditUrl } from './EditUrl';
import { Main } from './Main';
import { VisibilityOffConfirmation } from './VisibilityOffConfirmation';
import { VisibilityOnConfirmation } from './VisibilityOnConfirmation';

interface Props {
  onClose: () => void;
  leftButtonOnClick?: () => void;
}

export const SettingsRailContent: React.FC<Props> = ({ onClose, leftButtonOnClick }) => {
  const { data, loading } = useWeddingWebsiteQuery();
  const history = useHistory();

  const onDeactivate = () => {
    history.push('/gs/dashboard');
  };

  return (
    <>
      <RouterProvider entry="main">
        <Route
          screen="main"
          component={<Main loading={loading} leftButtonOnClick={leftButtonOnClick} onClose={onClose} data={data} />}
        />
        <Route screen="visibilityOffConfirmation" component={VisibilityOffConfirmation} />
        <Route screen="visibilityOnConfirmation" component={VisibilityOnConfirmation} />
        <Route screen="password" component={EditPassword} />
        <Route screen="url" component={EditUrl} />
        <Route
          screen="deactivate"
          component={<Deactivate onClose={leftButtonOnClick !== undefined ? onDeactivate : onClose} />}
        />
      </RouterProvider>
    </>
  );
};
